import type { GameId, PublicRoomInfo } from '@pixelworld/shared';
import { api } from '../../lib/api';

export const fetchPublicRooms = (gameId: GameId) =>
  api<{ rooms: PublicRoomInfo[] }>('GET', `/rooms?gameId=${encodeURIComponent(gameId)}`);
